import { Component, OnInit, ViewChild } from '@angular/core';
import { CompoundNameComponent } from '../../../shared/components/compound-name/compound-name.component';
import { CompoundNameComponent2 } from '../../../shared/components/compound-name2/compound-name2.component'
//import { CompoundDoubleNameComponent } from '../../../shared/components/compound-double-name/compound-double-name.component';
import { DaterangeComponent } from '../../../shared/components/daterange/daterange.component';
import { RoleComponent } from '../../../shared/components/role/role.component';
import { ContainsComponent } from '../../../shared/components/contains/contains.component';
import { RoleComponent2 } from '../../../shared/components/role2/role2.component'
import { CityTownEXComponent } from '../../../shared/components/city-town-ex/city-town-ex.component';
import { DoctypeexComponent } from '../../../shared/components/doctypeex/doctypeex.component';
import { Router } from '@angular/router';
import { RecSearchService } from '../../rec-search-service';
import { Store } from '@ngrx/store';
import { DatePipe } from '@angular/common';
import * as NameActions from './../../../store/actions/name.action';
import * as CompoundNameActions from './../../../store/actions/compoundname.action'
import * as RoleActions from './../../../store/actions/role.action';
import * as ContainsActions from './../../../store/actions/contains.action';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocTypeActions from './../../../store/actions/doctype.action';
import { CompoundAddressComponent } from '../../../shared/components/compound-address/compound-address.component';
import { CoreSearchDataState as AppState } from '../../../store/reducers/reducers';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';
import { GetSBImagesQuery, SBListDTO } from '../../../shared/viewmodels/ISearchService';
import { DateRangeParentComponent } from '../../../shared/components/date-range-parent/date-range-parent.component';




@Component({
  selector: 'app-rec-name-search',
  providers: [RecSearchService, ShoppingBasketService, DatePipe],
  templateUrl: './rec-name-search.component.html',
  styleUrls: ['./rec-name-search.component.css']
})
export class RecNameSearchComponent implements OnInit {
  @ViewChild(CompoundNameComponent, { static: false }) compoundNameChild;
  @ViewChild(CompoundNameComponent2, { static: false }) compoundNameChild2;
  //@ViewChild(DaterangeComponent) dateRangeChild;
  @ViewChild(DateRangeParentComponent, { static: true }) dateRangeChild;
  @ViewChild(RoleComponent, { static: false }) roleChild;
//  @ViewChild(ContainsComponent) containsChild;
  @ViewChild(RoleComponent2, { static: false }) roleChild2;
  @ViewChild(CityTownEXComponent, { static: false }) cityTownChild;
  @ViewChild(DoctypeexComponent, { static: false }) docTypeChild;
  @ViewChild('f', {static: true}) recNameSearchForm: NgForm;
  parentForm: FormGroup;
  latestRecording: string;

  recs: any;

  ngOnInit() {
    console.log('rec name search onInit');
    this.parentForm = this.fb.group({
      //compoundName: this.fb.group({
      //  lastcorpName: ['', Validators.required],
      //  fName: ['']
      //})
    });

    this.recNameSearchForm.form = this.fb.group({});

    if (this.dateRangeChild.utilityobj.fromDate == undefined)
      this.dateRangeChild.utilityobj.fromDate = '1/1/1962';

    if (this.dateRangeChild.utilityobj.toDate == undefined)
      this.dateRangeChild.utilityobj.toDate = new Date();

    this.service.getLatestRecording().subscribe(data =>
    {
      this.latestRecording = 'Index Search available from 1/1/1962 through ' + this.datepipe.transform(data.recDate, 'medium') + ' - Book ' + data.primaryID + ' Page ' + data.secondaryID ;
      }
    )
  
  }



  constructor(private router: Router, private service: RecSearchService, private store: Store<AppState>,
    private fb: FormBuilder, private sbService: ShoppingBasketService, private datepipe: DatePipe) {

    console.log('rec name search constr');
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.sbService.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.sbService.updateBasketCount(0);
    //this.sbService.updateBasketCount(cnt);
  }

  /**
   * Store the input parameters passed by user in the store.
   * @param fname
   * @param lname
   * @param fromdate
   * @param todate
   * @param roleid
   * @param citytowns
   * @param doctypes
   * @param streetnumber
   * @param streetaddress
   * @param book
   * @param page
   * @param docnum
   */
  addRecToStore(fname, lname, role, Contains, fname2, lname2, role2, fromdate, todate, citytowns, doctypes) {
    //this.store.dispatch(new RecActions.AddRec({
    //  fName: fname,
    //  lastcorpName: lname,
    //  fromDate: fromdate,
    //  toDate: todate,
    //  roleID: roleid,
    //  citytowns: citytowns,
    //  doctypes: doctypes,
    //  streetNumber: streetnumber,
    //  streetAddress: streetaddress,
    //  book: book,
    //  page: page,
    //  docnum: docnum,
    //  toAmount: '',
    //  fromAmount: ''

    //}));
    
    this.store.dispatch(new CompoundNameActions.AddName({
      fName: fname,
      lastcorpName: lname
    }));

    this.store.dispatch(new RoleActions.AddRole({
      roleID: role
    }));

   this.store.dispatch(new CompoundNameActions.AddName({
      fName: fname2,
      lastcorpName: lname2
    }));

    this.store.dispatch(new RoleActions.AddRole({
      roleID: role2
    }));

//    console.log('Contains - ' + Contains);

    this.store.dispatch(new ContainsActions.AddContains({
      contains: Contains
    }));

    
    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: fromdate,
      toDate: todate
    }));


    this.store.dispatch(new CityActions.AddCity({
      citytowns: citytowns
    }));

    this.store.dispatch(new DocTypeActions.AddDoct({
      doctypes: doctypes
    }));

    //this.store.select('coresearchdata').subscribe(data => this.recs = data);
    //console.log('city ' + this.recs.city[0].citytowns);
    //console.log('types - ' + this.recs.doct[0].doctypes);

  }

  /**
   * Delete input parameters from store.
   * @param index
   */
  delRecFromStore(index) {
    //this.store.dispatch(new RecActions.RemoveRec(index));
    this.store.dispatch(new NameActions.RemoveName(index));
    this.store.dispatch(new NameActions.RemoveName(index));
    //this.store.dispatch(new CompoundNameActions.RemoveName(index));
    this.store.dispatch(new RoleActions.RemoveRole(index));
    this.store.dispatch(new RoleActions.RemoveRole(index));
    this.store.dispatch(new ContainsActions.RemoveContains(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DocTypeActions.RemoveDoct(index));
  }

  /**
   * Search recorded land name search results.
   * @param url
   */
  search(url) {

    this.delRecFromStore(0);

    this.addRecToStore(
      this.compoundNameChild.utilityobj.fName,
      this.compoundNameChild.utilityobj.lastcorpName,
      this.roleChild.utilityobj.roleID,
      0, //this.containsChild.utilityobj.contains,
      this.compoundNameChild2.utilityobj.fName2,
      this.compoundNameChild2.utilityobj.lastcorpName2,
      this.roleChild2.utilityobj.role2ID,
      this.dateRangeChild.utilityobj.fromDate,
      this.dateRangeChild.utilityobj.toDate,
      this.cityTownChild.utilityobj.citytowns,
      this.docTypeChild.utilityobj.doctypes);

    //console.log('recnamesearch ' + this.containsChild.utilityobj.contains + ' ' + url);
    this.router.navigate([url]);

  }

  onSubmit(e) {
    if (this.recNameSearchForm.valid) {

      this.delRecFromStore(0);

      this.addRecToStore(
        this.compoundNameChild.utilityobj.fName,
        this.compoundNameChild.utilityobj.lastcorpName,
        this.roleChild.utilityobj.roleID,
        0, //this.containsChild.utilityobj.contains,
        this.compoundNameChild2.utilityobj.fName2,
        this.compoundNameChild2.utilityobj.lastcorpName2,
        this.roleChild2.utilityobj.role2ID,
        this.dateRangeChild.utilityobj.fromDate,
        this.dateRangeChild.utilityobj.toDate,
        this.cityTownChild.utilityobj.citytowns,
        this.docTypeChild.utilityobj.doctypes);

      this.router.navigate(['/rec-name-result-pg']);

    }
    else {
      this.validateAllFormFields(this.recNameSearchForm.form);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  ngAfterViewInit() {
    //this.parentForm.addControl('compoundName', this.compoundNameChild.form);
    //this.compoundNameChild.form.setParent(this.parentForm);

    this.recNameSearchForm.form.addControl('compoundNameForm', this.compoundNameChild.form);
    this.compoundNameChild.form.setParent(this.recNameSearchForm.form);

    //this.recNameSearchForm.form.addControl('compoundNameForm2', this.compoundNameChild2.form);
    //this.compoundNameChild2.form.setParent(this.recNameSearchForm.form);

    this.recNameSearchForm.form.addControl('dateRangeForm', this.dateRangeChild.form);
    this.dateRangeChild.form.setParent(this.recNameSearchForm.form);

    if (this.dateRangeChild.utilityobj.fromDate == undefined)
      this.dateRangeChild.utilityobj.fromDate = '1/1/1962';

    if (this.dateRangeChild.utilityobj.fromDate == undefined)
      this.dateRangeChild.utilityobj.toDate = new Date();

  }

  //download() {
  //  var query = new GetSBImagesQuery({
  //    emailAddress: "test@test.com",
  //    emailList: true,
  //    zipList: true      
  //  });

  //  query.sBList = new Array<SBListDTO>();
  //  query.sBList.push(new SBListDTO({
  //    bookDoc: "35000",
  //    bookPage: "1",
  //    wholeDoc: true,
  //    department: "R",
  //    imageType: "tif"
  //  }));
  //  query.sBList.push(new SBListDTO({
  //    bookDoc: "35000",
  //    bookPage: "1",
  //    wholeDoc: true,
  //    department: "R",
  //    imageType: "pdf"
  //  }));
  //  query.sBList.push(new SBListDTO({
  //    bookDoc: "602696",
  //    bookPage: "1",
  //    wholeDoc: true,
  //    department: "L",
  //    imageType: "tif",
  //    pages: ["0"]      
  //  }));

  //  query.sBList.push(new SBListDTO({
  //    bookDoc: "602696",
  //    bookPage: "1",
  //    wholeDoc: true,
  //    department: "L",
  //    imageType: "pdf",
  //    pages: ["0"]
  //  }));
  //  this.sbService.getSBImages(query).subscribe(blob => {
  //    const url = window.URL.createObjectURL(blob);
  //    window.open(url);
  //  })
  //}
}
